export default __webpack_public_path__ + "static/media/kapedicon.60ac59e7.png";